<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="name" description="Comprovante<br>de Resgate"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-7">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta Heppi</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ document | document }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ name }}
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="item-box">
            <div class="item-box-header"><h4>Valor (R$)</h4></div>
            <div class="item-box-content text-center py-7">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do resgate</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div v-if="description && description !== 'Saque' && description !== 'Resgate'" class="col-12 px-5 pt-5 pb-1">
              <h5>Descrição</h5>
              <div style="white-space: pre-line">{{ description }}</div>
            </div>
            <div v-if="bank" class="col-5 px-5 pt-5 pb-1">
              <h5>Conta bancária</h5>
              {{ bank.name }}
              <br>
              Agência: {{ bank.agency }}
              <br>
              Conta {{ bank.type }}: {{ bank.account }}
            </div>
            <div v-if="pix" class="col-5 px-5 pt-5 pb-1">
              <h5>PIX</h5>
              {{ pix }}
            </div>
            <div class="col-7 px-5 pt-5 pb-1">
              <h5>Titular</h5>
              {{ titular }}
              <br>
              CPF/CNPJ: {{ document | document }}
            </div>
            <div class="col-5 px-5 pt-1 pb-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMMM YYYY HH:mm') }}
              </div>
            </div>
            <div class="col-7 px-5 pt-1 pb-5">
              <h5>Código de autenticação</h5>
              {{ mp }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      name: '',
      heppiAccount: '',
      document: '',
      titular: '',
      amount: 0,
      bank: null,
      pix: null,
      date: '2022-09-26 16:21',
      mp: ''
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    }
  },
  async created () {
    if (this.transactionData) {
      this.loading = true
      try {
        // sender
        const accountId = this.transactionData.account_id
        const accountData = await axios.get('accounts/' + accountId + '?api_key=' + accountId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (accountData.data) {
          this.name = accountData.data.name
          this.heppiAccount = accountData.data.account_number
          this.document = accountData.data.owner.document
          this.titular = accountData.data.owner.name
          if (!this.transactionData.pix) {
            console.log(accountData.data.owner)
            this.bank = accountData.data.owner.bank_data
            this.bank = {
              name: accountData.data.owner.bank_data.name,
              agency: accountData.data.owner.bank_data.agency,
              account: accountData.data.owner.bank_data.account_number,
              type: accountData.data.owner.bank_data.type
            }
          }
        } else {
          this.error = true
        }
      } catch (error) {
        this.error = true
      }
      if (this.transactionData.pix) {
        this.pix = this.transactionData.pix.pix
      }
      this.amount = this.transactionData.amount
      this.date = this.$moment(this.transactionData.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
      this.description = this.transactionData.description
      this.mp = this.transactionData.withdraw
      this.loading = false
    }
    document.title = this.name + ' - resgate - ' + this.$moment(this.date).format('DD-MM-YYYY HH[h]mm')
  }
}

</script>
